import { cleanupPageMediaForNativePaywall } from '@/lib/native-revenuecat-launch';

const PRE_LAUNCH_FRAME_WAITS = 2;
const POST_CLEANUP_SETTLE_MS = 80;

async function waitForPaints(frameCount: number) {
  if (typeof window === 'undefined') return;

  for (let frame = 0; frame < frameCount; frame += 1) {
    await new Promise<void>((resolve) => {
      window.requestAnimationFrame(() => resolve());
    });
  }
}

export async function stageNativePaywallHandoff(logPrefix = '[RevenueCat]') {
  if (typeof window === 'undefined') return;

  console.log(`${logPrefix} Preparing lightweight native paywall handoff`);

  await waitForPaints(PRE_LAUNCH_FRAME_WAITS);
  cleanupPageMediaForNativePaywall(logPrefix);
  await waitForPaints(1);
  await new Promise((resolve) => window.setTimeout(resolve, POST_CLEANUP_SETTLE_MS));

  console.log(`${logPrefix} Native paywall handoff prepared`);
}